/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
import { ClientSDK } from "../lib/sdks.js";
import { Benefits } from "./benefits.js";
import { CheckoutLinks } from "./checkoutlinks.js";
import { Checkouts } from "./checkouts.js";
import { CustomerPortal } from "./customerportal.js";
import { Customers } from "./customers.js";
import { CustomerSessions } from "./customersessions.js";
import { CustomFields } from "./customfields.js";
import { Discounts } from "./discounts.js";
import { Events } from "./events.js";
import { ExternalOrganizations } from "./externalorganizations.js";
import { Files } from "./files.js";
import { LicenseKeys } from "./licensekeys.js";
import { Meters } from "./meters.js";
import { Metrics } from "./metrics.js";
import { Oauth2 } from "./oauth2.js";
import { Orders } from "./orders.js";
import { Organizations } from "./organizations.js";
import { Products } from "./products.js";
import { Refunds } from "./refunds.js";
import { Repositories } from "./repositories.js";
import { Subscriptions } from "./subscriptions.js";
export class Polar extends ClientSDK {
    get externalOrganizations() {
        return (this._externalOrganizations ?? (this._externalOrganizations = new ExternalOrganizations(this._options)));
    }
    get repositories() {
        return (this._repositories ?? (this._repositories = new Repositories(this._options)));
    }
    get organizations() {
        return (this._organizations ?? (this._organizations = new Organizations(this._options)));
    }
    get subscriptions() {
        return (this._subscriptions ?? (this._subscriptions = new Subscriptions(this._options)));
    }
    get oauth2() {
        return (this._oauth2 ?? (this._oauth2 = new Oauth2(this._options)));
    }
    get benefits() {
        return (this._benefits ?? (this._benefits = new Benefits(this._options)));
    }
    get products() {
        return (this._products ?? (this._products = new Products(this._options)));
    }
    get orders() {
        return (this._orders ?? (this._orders = new Orders(this._options)));
    }
    get refunds() {
        return (this._refunds ?? (this._refunds = new Refunds(this._options)));
    }
    get checkouts() {
        return (this._checkouts ?? (this._checkouts = new Checkouts(this._options)));
    }
    get files() {
        return (this._files ?? (this._files = new Files(this._options)));
    }
    get metrics() {
        return (this._metrics ?? (this._metrics = new Metrics(this._options)));
    }
    get licenseKeys() {
        return (this._licenseKeys ?? (this._licenseKeys = new LicenseKeys(this._options)));
    }
    get checkoutLinks() {
        return (this._checkoutLinks ?? (this._checkoutLinks = new CheckoutLinks(this._options)));
    }
    get customFields() {
        return (this._customFields ?? (this._customFields = new CustomFields(this._options)));
    }
    get discounts() {
        return (this._discounts ?? (this._discounts = new Discounts(this._options)));
    }
    get customers() {
        return (this._customers ?? (this._customers = new Customers(this._options)));
    }
    get customerPortal() {
        return (this._customerPortal ?? (this._customerPortal = new CustomerPortal(this._options)));
    }
    get customerSessions() {
        return (this._customerSessions ?? (this._customerSessions = new CustomerSessions(this._options)));
    }
    get events() {
        return (this._events ?? (this._events = new Events(this._options)));
    }
    get meters() {
        return (this._meters ?? (this._meters = new Meters(this._options)));
    }
}
//# sourceMappingURL=sdk.js.map